import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Vue from "vue";
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
// extend('required', {
//     ...required,
//     message: 'This field is required'
// });
// extend('min', {
//     validate(value, { length }) {
//         return value.length >= length;
//     },
//     params: ['length'],
//     message: 'The {_field_} field must have at least {length} characters'
// });

import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/en.json';

Object.keys(rules).forEach(rule => {
    extend(rule, {
        ...rules[rule], // copies rule configuration
        message: messages[rule] // assign message
    });
});

extend("phone", {
    validate: (value) => {
        return /^[0-9]{10}(?:-[0-9]{4})?$/.test(value);
    },
    message: "Phone number is invalid.",
});

// extend('min', {
//     validate(value, args) {
//         return value.length >= args.length;
//     },
//     params: ['length']
// });
